import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
  FETCH_VIDEOS_ERROR,
  UPDATE_VIDEOS_REQUEST,
  UPDATE_VIDEOS_SUCCESS,
  UPDATE_VIDEOS_ERROR,
  REMOVE_VIDEOS_SUCCESS,
  REMOVE_VIDEOS_ERROR,
  GET_PAGES,
  FETCH_LATEST_VIDEO_REQUEST,
  FETCH_LATEST_VIDEO_SUCCESS,
  FETCH_LATEST_VIDEO_ERROR,
} from 'actionTypes'

const getPages = (page, data, dispatch) => {
  const qtt = data.length
  const qtd = 10
  let pages = Math.floor(qtt / qtd)
  /* istanbul ignore else */
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchVideosSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}

/*
 * REQUEST VIDEOS
 */
export const fetchVideos =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchVideosRequest())

    return new Api(token, dispatch)
      .get(API_URL.VIDEOS_LIST)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(page, response.data, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchVideosError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchVideosRequest = () => ({
  type: FETCH_VIDEOS_REQUEST,
})

export const fetchVideosSuccess = (data, dispatch) => {
  /* istanbul ignore else */
  if (data) {
    dispatch(videosSuccess(data))
  }

  dispatch(hideSpinner())
}

const videosSuccess = (data) => ({
  type: FETCH_VIDEOS_SUCCESS,
  payload: data,
})

export const fetchVideosError = (error) => ({
  type: FETCH_VIDEOS_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE VIDEOS
 */
export const update =
  (token, toSave = null, callbackOnSuccess = null) =>
  (dispatch) => {
    dispatch(updateVideosRequest())

    return new Api(token, dispatch)
      .post(API_URL.VIDEOS_SAVE, toSave)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateVideosSuccess(response.data))
        dispatch(hideSpinner())
        dispatch(fetchVideos(token))
        /* istanbul ignore else */
        if (callbackOnSuccess) {
          callbackOnSuccess()
        }
      })
      .catch((error) => {
        dispatch(updateVideosError(error, toSave))
        dispatch(hideSpinner())
      })
  }

export const updateVideosRequest = () => ({
  type: UPDATE_VIDEOS_REQUEST,
})

export const updateVideosSuccess = (data) => ({
  type: UPDATE_VIDEOS_SUCCESS,
  payload: data,
})

export const updateVideosError = (error, toSave) => ({
  type: UPDATE_VIDEOS_ERROR,
  payload: { error, toSave },
})

/*
 * REMOVE VIDEOS
 */
export const remove = (token, toRemove) => (dispatch) => {
  const data = { ...toRemove, idVideo: toRemove.videoId }

  return new Api(token, dispatch)
    .post(API_URL.VIDEOS_REMOVE, data)
    .then(dispatch(showSpinner()))
    .then(() => {
      removeSuccess(token, dispatch)
    })
    .catch((error) => {
      dispatch(removeVideosError(error))
      dispatch(hideSpinner())
    })
}

/*
 * REMOVE LIST OF VIDEOS
 */
export const removeAll = (token, toRemove) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.VIDEOS_REMOVE_ALL, toRemove)
    .then(dispatch(showSpinner()))
    .then(() => {
      removeSuccess(token, dispatch)
    })
    .catch((error) => {
      dispatch(removeVideosError(error))
      dispatch(hideSpinner())
    })

const removeSuccess = (token, dispatch) => {
  dispatch(hideSpinner())
  dispatch(removeVideosSuccess())
  dispatch(fetchVideos(token))
}

export const removeVideosSuccess = () => ({
  type: REMOVE_VIDEOS_SUCCESS,
})

export const removeVideosError = (error) => ({
  type: REMOVE_VIDEOS_ERROR,
  payload: error,
})

/*
 * REQUEST LATEST VIDEO DATA
 */
export const fetchLatestVideoData = (token) => (dispatch) => {
  dispatch(fetchLatestVideoDataRequest())

  return new Api(token, dispatch)
    .get(API_URL.VIDEOS_LATEST)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchLatestVideoDataSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchLatestVideoDataError(error))
      dispatch(hideSpinner())
    })
}

export const fetchLatestVideoDataRequest = () => ({
  type: FETCH_LATEST_VIDEO_REQUEST,
})

export const fetchLatestVideoDataSuccess = (data) => ({
  type: FETCH_LATEST_VIDEO_SUCCESS,
  payload: data,
})

export const fetchLatestVideoDataError = (error) => ({
  type: FETCH_LATEST_VIDEO_ERROR,
  payload: error,
})
